// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"ed630c82","107":"d9f06877","316":"ed630c82","339":"97ca3502","716":"b0e4715e","757":"d9f06877","978":"457b66ad"}[chunkId] + ".chunk.css";
};